module.exports = __webpack_public_path__ + "img/sample-chinese-new.eaa4f713.png";